import { FunctionComponent } from 'react'

type IPageTemplate = {
	testid?: string
	children: React.ReactNode
}

const PublicPageTemplate: FunctionComponent<IPageTemplate> = ({ children, testid }) => (
	<div
		data-testid={testid}
		className='pt-3xl mx-lg p-4 flex flex-col'
	>
		{children}
	</div>
)

export default PublicPageTemplate
